const state = {
  streams: [{},{},{},{}],
  index: null,
  search: false,
  filter: ''
}

const actions = {}

const mutations = {
  setStream (state, data) {
    if (state.index !== null) {
      state.streams[state.index] = data
      state.index = null
    }
  },
  setIndex (state, index) {
    state.index = index
  },
  toggleSearch(state) {
    state.search = !state.search
  },
  setFilter (state, data) {
    state.filter = data
  }
}

const getters = {
  getStreams (state) {
    return state.streams
  },
  isSearch(state) {
    return state.search
  },
  getFilter(state) {
    return state.filter
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
